'use client';

import { MouseEvent, RefObject, useCallback, useRef } from 'react';

export function useDragScroll(ref: RefObject<HTMLElement | null>) {
  const isDownRef = useRef<boolean>(false);
  const startXRef = useRef<number>(0);
  const scrollLeftRef = useRef<number>(0);

  const onMouseDown = useCallback(
    (e: MouseEvent) => {
      if (!ref.current) return;
      isDownRef.current = true;
      startXRef.current = e.pageX - ref.current.offsetLeft;
      scrollLeftRef.current = ref.current.scrollLeft;
    },
    [ref],
  );

  const onMouseMove = useCallback(
    (e: MouseEvent) => {
      if (!isDownRef.current || !ref.current) return;
      e.preventDefault();
      const x = e.pageX - ref.current.offsetLeft;
      const walkX = x - startXRef.current;
      // oxlint-disable-next-line no-param-reassign
      ref.current.scrollLeft = scrollLeftRef.current - walkX;
    },
    [ref],
  );

  const onMouseUp = useCallback(() => {
    isDownRef.current = false;
  }, []);

  const onMouseLeave = useCallback(() => {
    isDownRef.current = false;
  }, []);

  return { onMouseDown, onMouseMove, onMouseUp, onMouseLeave };
}
